import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ImportStateService {
  private _forceClassroomReload$ = new BehaviorSubject<boolean>(false);

  setForceClassroomReload(value: boolean) {
    this._forceClassroomReload$.next(!!value);
  }

  getForceClassroomReload(): boolean {
    const val = this._forceClassroomReload$.getValue();
    if (val) {
      this._forceClassroomReload$.next(false);
    }
    return val;
  }

  /** Resets the stateful properties of this service. */
  reset() {
    this._forceClassroomReload$.next(false);
  }
}
